import { useSelector } from 'react-redux';

import { getBreadcrumbs } from 'selectors';

import { useSelectorProps } from './useSelectorProps';

export const useBreadcrumbs = (breadcrumbsPlaceholders = []) => {
  const selectorProps = useSelectorProps();
  const { items: breadcrumbs } = useSelector(state =>
    getBreadcrumbs(state, selectorProps)
  );

  if (!breadcrumbs) return [];

  // breadcrumbs returned from API may not contain all items, because SEO engineer
  // is not entered all data yet. In such a case we need to use a default.
  if (breadcrumbsPlaceholders.length > breadcrumbs.length) {
    return breadcrumbs.concat(
      breadcrumbsPlaceholders.slice(breadcrumbs.length)
    );
  }

  return breadcrumbs;
};

export default useBreadcrumbs;
